export const PLACEMENT = {
  TOP: 'top',
  BOTTOM: 'bottom',
} as const;

export const OVERFLOW_SIDE = {
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right',
} as const;

export const ALIGN_TYPES = {
  LEFT: 'left',
  RIGHT: 'right',
  TRIGGER_WIDTH: 'triggerWidth',
} as const;

export const SELECT_MODES = {
  SINGLE: 'single',
  MULTIPLE: 'multiple',
} as const;

export const SIZE = {
  DEFAULT: 'default',
  SMALL: 'small',
} as const;

export const INPUT_SIZE_MAP = {
  [SIZE.DEFAULT]: 'basic',
  [SIZE.SMALL]: 'small',
} as const;

export const KEYS = {
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  SPACE: 'Space',
  TAB: 'Tab',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
};

export const KEY_VALUES = {
  [KEYS.ENTER]: KEYS.ENTER,
  [KEYS.ESCAPE]: KEYS.ESCAPE,
  [KEYS.TAB]: KEYS.TAB,
  [KEYS.ARROW_UP]: KEYS.ARROW_UP,
  [KEYS.ARROW_DOWN]: KEYS.ARROW_DOWN,
  ' ': KEYS.SPACE,
  13: KEYS.ENTER,
  27: KEYS.ESCAPE,
  32: KEYS.SPACE,
} as const;

export const ANIMATION_TIMEOUT = 300;

export const CONTENT_MARGIN = 4;
export const PAGE_PADDING = 16;
export const DEFAULT_CONTENT_HEIGHT_WITHOUT_PADDING = 304;
export const MAX_CONTENT_WIDTH = 328;
export const ICON_OFFSET = 54;
